import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import moment from "moment";
import ImgComponent from "../../../../parts/ImgComponent";
import getCycleCardImagePath from "../../../../utils/get-cycle-card-image-path";

const calculateCycleWorkouts = (cycle) => {
  if (!cycle) return 0;

  const totalSessions = cycle.programs.reduce((acc, program) => {
    return acc + program.sessions.length;
  }, 0);

  return totalSessions;
};

const TeamInformation = ({ locals }) => {
  const { t } = useTranslation("coaching-portal");
  const cycle = locals?.editCycle;

  const image = getCycleCardImagePath(cycle);

  const [imgError, setImgError] = useState(false);

  const infoItems = [
    { label: t("teams.teamInformation.teamName"), value: cycle.name },
    { label: t("teams.teamInformation.description"), value: cycle.description },
    { label: t("teams.teamInformation.experienceLevel"), value: cycle.difficulty },
    { label: t("teams.teamInformation.activeMembers"), value: cycle.members?.length || 0 },
    {
      label: t("teams.teamInformation.firstDayOfWeek"),
      value: moment()
        .weekday(cycle.firstDayOfWeek || 0)
        .format("dddd"),
    },
    {
      label: t("teams.teamInformation.startedOn"),
      value: moment(cycle?.programs[0]?.startDate, "YYYYMMDD").format(
        "MMM D, YYYY"
      ),
    },
    { label: t("teams.teamInformation.totalWorkout"), value: calculateCycleWorkouts(cycle) },
    {
      label: t("teams.teamInformation.status"),
      value: cycle.status === "published" ? t("teams.teamInformation.published") : t("teams.teamInformation.unpublished"),
    },
  ];

  return (
    <article className="team-information">
      <div className="image-side">
        <article className={`image-container ${imgError ? "error" : ""}`}>
          <ImgComponent
            image={image}
            classNames={`program-image ${
              image.startsWith("data:image") ? "no-image" : ""
            }`}
            altText={t("teams.teamInformation.programThumbnailAlt")}
            onErrorFn={() => {
              setImgError(true);
            }}
          />
        </article>

        <div className="buttons">
          <a
            role="button"
            data-button-type="primary"
            href={`/actions/refresh?modal[type]=edit-team-info&cycleId=${cycle._id}&storeType=teams`}
          >
            {t("teams.teamInformation.editTeamInfo")}
          </a>
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            href={`/actions/refresh?modal[type]=end-team&cycleId=${cycle._id}`}
          >
            {t("teams.teamInformation.endTeam")}
          </a>
        </div>
      </div>
      <div className="table-side">
        <div className="team-info-table">
          {infoItems.map((item, index) => (
            <InfoRow
              key={`team-info-row-${index}`}
              label={item.label}
              value={item.value}
            />
          ))}

          <InfoRow
            label={t("teams.teamInformation.introVideo")}
            value={
              cycle.video ? (
                <a
                  role="button"
                  data-button-type="secondary"
                  className="play-button"
                  href={`/actions/refresh?modal[type]=week-video&video=${cycle.video}&cycleVideo=true`}
                >
                  <SvgIcon
                    className="yellow"
                    src="/img/new-icons/play-white.svg"
                    alt={t("teams.programManager.editAlt")}
                  />
                  {t("teams.teamInformation.play")}
                </a>
              ) : (
                <p>{t("teams.teamInformation.noVideo")}</p>
              )
            }
            lastItem
          />
        </div>
      </div>
    </article>
  );
};

const InfoRow = ({ label, value }) => {
  return (
    <div className={`team-info-row`}>
      <div className={`w-1/3`}>
        <p className="opacity-70">{label}</p>
      </div>
      <div className="w-2/3">
        <p>{value}</p>
      </div>
    </div>
  );
};

export default TeamInformation;
